import { API } from '../Api';

/**
 * Đồng ý điều khoản từng tính năng (consent-to-terms).
 * Gọi cab-user-service qua gateway /v1/user-service/Consent/... (gateway tự inject auid).
 */
const BASE = '/v1/user-service/Consent';

export interface PolicyConsentStatus {
  key: string;
  title: string;
  currentVersion: string;
  acceptedVersion?: string | null;
  accepted: boolean; // đã đồng ý đúng phiên bản hiện tại
}

/** Trạng thái đồng ý các điều khoản (keys: mảng policyKey; trống = tất cả). */
export const getConsentStatus = async (keys?: string[]): Promise<PolicyConsentStatus[]> => {
  const q = keys && keys.length ? `?keys=${encodeURIComponent(keys.join(','))}` : '';
  const res = await API.get(`${BASE}/status${q}`);
  return res.data?.data ?? res.data ?? [];
};

/** Ghi nhận user đồng ý 1 điều khoản (phiên bản hiện tại). */
export const acceptPolicy = async (policyKey: string): Promise<void> => {
  await API.post(`${BASE}/accept`, { policyKey });
};
